// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"e8238ca5","787":"77539971"}[chunkId] + ".chunk.js";
};